export const FOLLOW_UP_COMMENTS_VALIDATION_RULES = {
  comment: {
    isRequiredTrim: {
      value: true,
    },
  },
  value: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/comments/followUpCommentsValidationRules.js